import { createChannelManagementInstance } from '../api-instance';
import type { TRequestOptions } from '../types';
import type { IChannelDetailsDto } from './types';
export { updateVkChannel } from './vk';
export type { VkAuthorizeRequest } from './vk';

export {
  deleteChannelById,
  getChannelById,
  getChannelLogsByChannelId,
  getChannels,
  initiateCreateChannel,
  initSMS,
  qrLoginChannel,
  sendTgPersonalPassword,
  updateChannelById,
  updateMaxBotChannel,
  updateNumber,
  updateTgBotChannel,
  verifySMS,
} from './generate/channels.gen';
export {
  getExternalChannelById,
  privateSendTgPersonalPassword,
} from './generate/channels-internal.gen';
export type {
  GetChannelLogsByChannelIdParams,
  IAuthorizeMaxBotChannelRequest,
  IAuthorizeTgBotChannelRequest,
  IChannelDetailsDto,
  IChannelDto,
  IChannelsListResponseDto,
  IChannelsParamsDto,
  ICreateChannelResponseDto,
  IExternalChannelQrResponseDTO,
  IGetChannelLogsByChannelIdResultDto,
  IInitSmsQueryDTO,
  IUpdateChannelRequestDto,
  Log,
  TChannelTypeDto,
} from './types';

export const deleteBotTokenByChannelId = (
  channelId: string,
  options?: TRequestOptions
): Promise<IChannelDetailsDto> =>
  createChannelManagementInstance<IChannelDetailsDto>(
    { url: `/api/v1/channels/${channelId}/bot-token`, method: 'DELETE' },
    options
  );
